import request from '@/api/request.js'

// 登录
export function SystemUserLogin(data) {
    return request({
        url: '/api/user/systemuserlogin',
        method: 'post',
        data: data
    })
}

// 验证
export function SystemUserVerify(data) {
    return request({
        url: '/api/user/systemuserverify',
        method: 'post',
        data: data
    })
}

// 修改
export function SystemUserModify(data) {
    return request({
        url: '/api/user/systemusermodify',
        method: 'post',
        data: data
    })
}

// 新增
export function SystemUserInsert(data) {
    return request({
        url: '/api/user/systemuserinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemUserDelete(id) {
    return request({
        url: `/api/user/systemuserdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemUserUpdate(id, data) {
    return request({
        url: `/api/user/systemuserupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemUserGetById(id) {
    return request({
        url: `/api/user/getsystemuserbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemUserGetList(params) {
    return request({
        url: '/api/user/getsystemuserlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemUserGetPageList(params) {
    return request({
        url: '/api/user/getsystemuserpagelist',
        method: 'get',
        params: params
    })
}